// src/components/DataLoader.jsx - Retry Butonu ile

import React from 'react';
import { RefreshCw, Database, AlertCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const DataLoader = ({ message, onRetry }) => {
    const { t } = useLanguage();

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
            <div className="text-center max-w-2xl">
                {/* Logo */}
                <div className="mb-8">
                    <img
                        src="/procon-logo.png"
                        alt="ProconSport"
                        className="h-20 mx-auto mb-4"
                        onError={(e) => e.target.style.display = 'none'}
                    />
                </div>

                {message ? (
                    // Hata veya Bilgi Mesajı
                    <div className="bg-white rounded-2xl shadow-lg p-10">
                        <AlertCircle className="text-orange-500 mx-auto mb-6" size={64} />
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">
                            {t('dataLoader.loadIssueTitle')}
                        </h2>
                        <p className="text-gray-600 mb-8 text-lg leading-relaxed">
                            {message}
                        </p>

                        {/* Dosya Konumu Bilgisi */}
                        <div className="bg-gray-50 rounded-xl p-6 text-left mb-6">
                            <p className="font-bold text-gray-800 mb-3 flex items-center gap-2">
                                <Database size={20} />
                                {t('dataLoader.fileLocationLabel')}
                            </p>
                            <code className="block bg-gray-800 text-green-400 px-4 py-3 rounded-lg text-sm font-mono mb-4">
                                public/data/TurfBox/*.xlsx
                            </code>
                            <div className="text-sm text-gray-600 space-y-2">
                                <p>
                                    <strong>1.</strong> {t('dataLoader.step1Prefix')}{' '}
                                    <code className="bg-gray-200 px-2 py-1 rounded">public/data/TurfBox/</code>{' '}
                                    {t('dataLoader.step1Suffix')}
                                </p>
                                <p>
                                    <strong>2.</strong> {t('dataLoader.step2Label')}{' '}
                                    <code className="bg-gray-200 px-2 py-1 rounded text-xs">Cihaz-84285.xlsx</code>
                                </p>
                                <p>
                                    <strong>3.</strong> <code className="bg-gray-200 px-2 py-1 rounded">src/App.js</code>{' '}
                                    {t('dataLoader.step3Suffix')}
                                </p>
                            </div>
                        </div>

                        {/* Örnek Dosya İsimleri */}
                        <div className="bg-blue-50 border border-blue-200 rounded-xl p-6 text-left mb-6">
                            <p className="font-bold text-blue-900 mb-3">{t('dataLoader.sampleFileNames')}</p>
                            <div className="space-y-1 text-sm">
                                <code className="block bg-white px-3 py-2 rounded text-blue-700">
                                    TurfBox/Cihaz-84285.xlsx
                                </code>
                                <code className="block bg-white px-3 py-2 rounded text-blue-700">
                                    TurfBox/Cihaz-002.xlsx
                                </code>
                            </div>
                        </div>

                        {/* Retry Button */}
                        {onRetry && (
                            <button
                                onClick={onRetry}
                                className="inline-flex items-center gap-3 px-8 py-4 bg-gray-700 hover:bg-gray-800 text-white rounded-xl font-bold text-lg shadow-lg hover:shadow-xl transition-all duration-300 group"
                            >
                                <RefreshCw size={24} className="group-hover:rotate-180 transition-transform duration-500" />
                                {t('dataLoader.retry')}
                            </button>
                        )}
                    </div>
                ) : (
                    // Yükleniyor Animasyonu
                    <div className="bg-white rounded-2xl shadow-lg p-10">
                        <Database className="text-gray-400 mx-auto mb-6 animate-pulse" size={64} />
                        <h2 className="text-3xl font-bold text-gray-900 mb-4">
                            {t('dataLoader.loadingTitle')}
                        </h2>
                        <p className="text-gray-600 mb-8 text-lg">
                            {t('dataLoader.loadingMessage')}
                        </p>
                        <div className="flex items-center justify-center gap-2">
                            <RefreshCw className="animate-spin text-gray-400" size={32} />
                            <div className="flex gap-1">
                                <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                                <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                                <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Console Mesajı */}
                <p className="mt-6 text-sm text-gray-500">
                    {t('dataLoader.consoleHintPrefix')} <strong>Console</strong>{t('dataLoader.consoleHintSuffix')}
                </p>
            </div>
        </div>
    );
};

export default DataLoader;
